/* ReviewAndInstall.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _8 = "@media (min-width:48rem){._e8ghesu3{justify-content:flex-end}._15fl1ejb{margin-top:var(--ds-space-300,24px)}}";
const _7 = "._19pkpxbi{margin-top:var(--ds-space-200,1pc)}";
const _6 = "@media not all and (min-width:48rem){._1s6bukr8{margin:var(--ds-space-negative-400,-2pc)}}";
const _5 = "._ect48a9y{font-family:var(--ds-font-family-brand-body,Charlie Text)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives';
import { InstallDialogEditionHeader as AppHeader } from '@atlassian/mpac-ui';
import { InstallableAppPrivacyInformation } from '../../InstallableAppPrivacyInformation';
import { ScreenTitle } from '../../ScreenTitle';
import { Pricing } from '../Pricing';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _4 = "@media (min-width:48rem){._19wgxy5q{gap:var(--ds-space-400,2pc)}}";
const _3 = "._2lx21bp4{flex-direction:column}";
const _2 = "._1e0c1txw{display:flex}";
const _ = "._zulp1ejb{gap:var(--ds-space-300,24px)}";
const pricingContainerStyles = null;
const reviewAndInstallScreenStyles = null;
const ReviewAndInstallContent = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_zulp1ejb _1e0c1txw _2lx21bp4 _19wgxy5q", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ReviewAndInstallContent.displayName = 'ReviewAndInstallContent';
}
export const ReviewAndInstall = _ref2 => {
  let {
    appHeaderDetails,
    links,
    appDetails,
    hostStatusResponse,
    installedAppDetailsResult,
    cmtAvailabilityResult
  } = _ref2;
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_5, _6]
    }), /*#__PURE__*/_jsxs("div", {
      className: ax(["_ect48a9y _1s6bukr8"]),
      children: [/*#__PURE__*/_jsx(ScreenTitle, {
        title: "Review and install",
        stepInfo: "Step 2 of 2"
      }), /*#__PURE__*/_jsxs(ReviewAndInstallContent, {
        children: [/*#__PURE__*/_jsx(AppHeader, {
          appHeaderDetails: appHeaderDetails,
          appIconLink: appDetails.appIconLink,
          appRatingLink: links.appRating,
          isAppCloudFortified: appDetails.isAppCloudFortified,
          bugBountyParticipant: appDetails.bugBountyParticipant,
          headerInjection: /*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_7, _2, _8]
            }), /*#__PURE__*/_jsx("div", {
              className: ax(["_19pkpxbi _1e0c1txw _e8ghesu3 _15fl1ejb"]),
              children: /*#__PURE__*/_jsx(Pricing, {
                appDetails: appDetails,
                hostStatusResponse: hostStatusResponse,
                installedAppDetailsResult: installedAppDetailsResult,
                cmtAvailabilityResult: cmtAvailabilityResult,
                links: links
              })
            })]
          })
        }), /*#__PURE__*/_jsx(InstallableAppPrivacyInformation, {
          links: links,
          appName: appDetails.appName,
          partner: appDetails.partner,
          privacyPolicyUrl: appDetails.privacyPolicyUrl,
          endUserLicenseAgreementUrl: appDetails.endUserLicenseAgreementUrl,
          appIdentifier: appDetails.appIdentifier
        })]
      })]
    })]
  });
};